import { ResponseCode } from '@base/utils/constants';

export const regExpEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const regExpPassword = /^[a-zA-Z0-9_.-]*\w{6,}$/;
export type FromSocial = {
  from: string;
};

export enum OAuthProvider {
  FACEBOOK = 'facebook',
  GOOGLE = 'google',
  APPLE = 'apple,',
}

export const loginMessages: Record<number, string> = {
  [ResponseCode.USER_NOT_FOUND]: 'user_not_found',
  [ResponseCode.UNKNOWN_USER]: 'confirm_email_error_wrong_auth',
  [ResponseCode.AN_ERROR_OCCURED]: 'banned_from_server',
  [ResponseCode.AN_ERROR_OCCURED2]: 'banned_from_server',
  [ResponseCode.LOGIN_IS_NOT_AVAILABLE]: 'login_name_not_available',
  [ResponseCode.CANT_CREATE_SESSION]: 'Can not create session',
  [ResponseCode.OLD_VERSION_GAME]: 'login_old_version_title',
  [ResponseCode.THIS_ACCOUNT_LOCKED]: 'this_account_is_locked',
};

export const registrationMessages: Record<number, string> = {
  [ResponseCode.SUCCESS]:
    'Your account has been successfully registered. An account confirmation email has been sent to your mail. You need to verify your account in order to log in.',
  [ResponseCode.NOT_AVAILABLE_NOW]: 'registration_not_available',
  [ResponseCode.REQUIRED_PARAMETER_IS_MISSING]: 'fill_all_required_fields',
  [ResponseCode.BAD_PASSWORD]: 'incorrect_password',
  [ResponseCode.WRONG_EMAIL_OR_PASSWORD]: 'change_email_error_wrong_email',
  [ResponseCode.CANT_CREATE_SESSION]: 'Can not create session',
  [ResponseCode.NAME_IS_NOT_AVAILABLE]: 'login_name_not_available',
  [ResponseCode.NAME_IS_ALREADY_USED]: 'login_already_in_use',
};

export const resetPasswordMessages: Record<number, string> = {
  [ResponseCode.SUCCESS]: 'password_changed_successfully',
  [ResponseCode.MATCH_IS_NOT_FOUND]: 'user_not_found',
};
